"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@awesome.me/kit-c10ef98ed3/icons/classic/regular";
import { trackCtaClick } from "@/utils/commonEvents";
import { Noise } from "@/components/Noise/Noise";
import { resmed_peaceful_purple_light } from "@/constants/resmedColours";
import { getAssetUrl } from "@/utils/assetUrl";
import { appendSessionUtmsToUrl } from "@/utils/utms";

const BOOK_APPOINTMENT_URL = "https://sleep.resmed.com/#insurance-check-section";

export default function BookAppointmentSectionDefault() {
  const t = useTranslations("results-page.book-appointment-section");
  const bookingUrl = appendSessionUtmsToUrl(BOOK_APPOINTMENT_URL);

  return (
    <section className="book-appointment-section-default">
      <Noise
        noiseSize={0.3}
        density={0.7}
        colour={resmed_peaceful_purple_light}
        opacity={0.25}
        filterId="bookAppointmentDefaultNoise"
      />
      <h2 className="headline book-appointment-section-headline">
        {t.rich("take-the-next-step", {
          highlight: (chunks) => (
            <span className="book-appointment-section-headline-highlight">
              {chunks}
            </span>
          ),
        })}
      </h2>

      <div className="book-appointment-section-content">
        <div className="book-appointment-section-body">
          <p>
            {t.rich("you-dont-have-to", {
              bold: (chunks) => <strong>{chunks}</strong>,
              br: () => <br />,
            })}
          </p>
        </div>

        <div className="book-appointment-section-buttons">
          <Button
            variant="contained"
            color="secondary"
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="book-appointment-section-button"
            disableRipple
            onClick={() =>
              trackCtaClick({
                componentName: "sleep_assessment_pro",
                clickedArea: "Book now",
                clickedText: t("book-a-virtual-visit"),
                clickedUrl: bookingUrl,
              })
            }
          >
            {t("book-a-virtual-visit")}
            <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
          </Button>
        </div>
      </div>

      <div className="book-appointment-section-image-container">
        <Image
          className="book-appointment-section-image"
          src={getAssetUrl("/images/results/book_appointment_default.webp")}
          alt={t("doctor-image-alt")}
          width={600}
          height={800}
          unoptimized
        />
      </div>
    </section>
  );
}
